import React from 'react';
import ReactDOM from 'react-dom/client';
//import './index.css';
import { Provider } from 'react-redux';
import { BrowserRouter, HashRouter, Route, Routes } from 'react-router-dom';
import App from './App';
import { store } from './app/store';
import reportWebVitals from './reportWebVitals';

import global_en from "./translations/en.json";
import global_it from "./translations/it.json";

import absenceReport_en from "./features/hr/absenceReport/translations/en.json";
import absenceReport_it from "./features/hr/absenceReport/translations/it.json";

import whistle_en from "./features/whistle/translations/en.json";
import whistle_it from "./features/whistle/translations/it.json";

import safety_en from "./features/safety/translations/en.json";
import safety_it from "./features/safety/translations/it.json";

import health_en from "./features/health/translations/en.json";
import health_it from "./features/health/translations/it.json";

import device_en from "./features/device/translations/en.json";
import device_it from "./features/device/translations/it.json";

import ai_en from "./features/ai/translations/en.json";
import ai_it from "./features/ai/translations/it.json";

import attendance_en from "./features/attendance/translations/en.json";
import attendance_it from "./features/attendance/translations/it.json";

import domus_en from "./features/domus/translations/en.json";
import domus_it from "./features/domus/translations/it.json";

import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';

const defaultLang = "it"
const starLang = localStorage.getItem("lang") ? localStorage.getItem("lang") : defaultLang;



i18next.init({
  interpolation: { escapeValue: false },
  lng: starLang,
  resources: {
    en: {
      global: global_en,
      absenceReport: absenceReport_en,
      whistle: whistle_en,
      safety: safety_en,
      health: health_en,
      device: device_en,
      ai: ai_en,
      attendance: attendance_en,
      domus: domus_en
    },
    it: {
      global: global_it,
      absenceReport: absenceReport_it,
      whistle: whistle_it,
      safety: safety_it,
      health: health_it,
      device: device_it,
      ai: ai_it,
      attendance: attendance_it,
      domus: domus_it
    }

  }

})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <I18nextProvider i18n={i18next}>
    <Provider store={store}>
      <HashRouter>
        <Routes>
          <Route path="/*" element={<App />} />
        </Routes>
      </HashRouter>
    </Provider>
  </I18nextProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
